import { _js } from '@ifixit/localize';
import conclusionTemplate from 'ejs/embed/embed.v4.conclusion.ejs';
import Template from 'Shared/template';

export function ConclusionController(fullScreenController, prepareEmbed) {
   let template = prepareEmbed(Template.get(conclusionTemplate));
   let element;

   function getElement(guide) {
      if (element) {
         return element;
      }
      guide.pageTitle = _js('Conclusion');
      element = template(guide);
      if (!fullScreenController.supported()) {
         element.find('.js-fullscreen').hide();
      }
      return element;
   }

   return {
      getElement: getElement,
   };
}
